<script lang="ts">
import RollingCounter from '@/components/common/RollingCounter.vue'
import { defineComponent } from 'vue'

/**
 * A card to display the progress of a game.
 *
 */
export default defineComponent({
  components: { RollingCounter },
  props: {
    prizesLeft: {
      type: Number,
      required: false,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    progressContent(): Record<string, string> {
      return this.prizesLeft > 0
        ? {
            class: `bg-primary-lighter`,
            text: `Prize${this.prizesLeft > 1 ? 's' : ''} Left`,
            value: this.$n(this.prizesLeft, 'number'),
          }
        : {
            class: 'bg-[#E2EAED]',
            text: 'No Prizes Left',
            value: 'Sold Out',
          }
    },
  },
})
</script>

<template>
  <div
    class="border rounded-md p-2 @sm/main:p-3 mb-2"
    :class="progressContent.class"
  >
    <div class="bg-pure-white border rounded-md p-1 @sm/main:p-2 text-center">
      <RollingCounter
        v-if="prizesLeft > 0"
        :value="prizesLeft"
        :duration="1000"
        class="text-md/5 @sm/main:text-xl/6 font-bold"
      />
      <span v-else class="text-md/5 @sm/main:text-xl/6 font-bold"
        >Sold Out</span
      >
      <br />
      <span class="text-md/4 @sm/main:text-md/5 font-normal">
        {{ progressContent.text }}
      </span>
    </div>
  </div>
</template>
